import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import Header from "../Header/Header";
import styles from "./Hero.module.css";
import Slider from "react-slick";
import data from "../../views/ServiceDetailsPage/data";
import landing from "../../assets/hero.png";
import { ORDER_LINK } from "../../constant/links";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";

const Hero = ({ title, list, img, subtitle, colored, home, slug }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  const heroConf = {
    title: "WE PROVIDE MANUFACTURING SUPPORT INCLUDING",
    img: landing,
    list: [
      "3D Printing",
      "Laser Cutting",
      "PCB Manufacturing",
      "Silicon Molding",
      "Product Development",
    ],
  };
  return (
    <div className="position-relative">
      <Header />
      <div className={styles.wrapper}>
        <Container className={`pt-5 ${styles.container}`}>
          {home === true ? (
            <div>
              <Slider {...settings}>
                <div className="h-100">
                  <Row className="mx-0">
                    <Col
                      md={6}
                      className="d-flex flex-column justify-content-center"
                    >
                      <h2 className={`text-white pb-4 ${styles.title}`}>
                        {heroConf.title}
                      </h2>
                      <h2 className={`text-white pb-4 ${styles.subtitle}`}>
                        {heroConf.subtitle}
                      </h2>
                      {heroConf.list ? (
                        <div
                          className={`${
                            colored ? styles.list : styles.ul
                          } ps-2 pb-4`}
                        >
                          <ul>
                            {heroConf.list.map((item, index) => (
                              <li key={index}> {item}</li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <></>
                      )}
                      <a
                        href={ORDER_LINK}
                        // to={`/order?type=${slug ? slug : ""}`}
                        target={"_blank"}
                        rel="noopener noreferrer"
                        className="btn_primary"
                      >
                        Order Now
                      </a>
                    </Col>
                    <Col
                      md={5}
                      className="d-flex justify-content-center align-items-center pt-md-0 pt-5"
                    >
                      <img
                        src={heroConf.img}
                        alt={heroConf.title}
                        className={styles.img}
                      />
                    </Col>
                  </Row>
                </div>
                {data.map((item) => (
                  <div className={""} key={item.slug}>
                    <Row className="mx-0">
                      <Col md={6} className="pt-md-5 pt-0">
                        <h2 className={`text-white pb-4 ${styles.title}`}>
                          {item.data.title}
                        </h2>
                        <h2 className={`text-white pb-4 ${styles.subtitle}`}>
                          {item.data.subtitle}
                        </h2>
                        {item.data.list ? (
                          <div
                            className={`${
                              colored ? styles.list : styles.ul
                            } ps-2 pb-4`}
                          >
                            <ul>
                              {item.data.list.map((item, index) => (
                                <li key={index}> {item}</li>
                              ))}
                            </ul>
                          </div>
                        ) : (
                          <></>
                        )}
                        <a
                          href={ORDER_LINK}
                          // to={`/order?type=${item.slug ? item.slug : ""}`}
                          target={"_blank"}
                          rel="noopener noreferrer"
                          className="btn_primary"
                        >
                          Order Now
                        </a>
                      </Col>
                      <Col
                        md={5}
                        className="d-flex justify-content-center align-items-center pt-md-0 pt-5"
                      >
                        <img
                          src={item.data.img}
                          alt={item.data.title}
                          className={styles.img}
                        />
                      </Col>
                    </Row>
                  </div>
                ))}
              </Slider>
            </div>
          ) : (
            <>
              <div className="">
                <Row className="mx-0">
                  <Col md={6} className="pt-md-5 pt-0">
                    <h2 className={`text-white pb-4 ${styles.title}`}>
                      {title}
                    </h2>
                    <h2 className={`text-white pb-4 ${styles.subtitle}`}>
                      {subtitle}
                    </h2>
                    {list ? (
                      <div
                        className={`${
                          colored ? styles.list : styles.ul
                        } ps-2 pb-4`}
                      >
                        <ul>
                          {list.map((item, index) => (
                            <li key={index}> {item}</li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <></>
                    )}
                    <a
                      href={ORDER_LINK}
                      // to={`/order?type=${slug ? slug : ""}`}
                      target={"_blank"}
                      rel="noopener noreferrer"
                      className="btn_primary"
                    >
                      Order Now
                    </a>
                  </Col>
                  <Col
                    md={5}
                    className="d-flex justify-content-center align-items-center pt-md-0 pt-5"
                  >
                    <img src={img} alt="" className={styles.img} />
                  </Col>
                </Row>
              </div>
            </>
          )}
          <Marquee gradientColor={"#110E2D"} className={styles.marq}>
            <p>
              **News,Breaking News,Notice ETC,News,Breaking News,Notice
              ETC,News,Breaking News,Notice ETC,...**
            </p>
          </Marquee>
        </Container>
      </div>
    </div>
  );
};

export default Hero;
